import { useEffect } from 'react';

// @ts-expect-error - useErrorHandler does not have types
import { useErrorHandler } from 'src/services/useErrorHandler';
// @ts-expect-error - useUserActions does not have types
import { useUserActions } from 'src/store';

export const useLoadRecentlyUsedContentTypes = () => {
  const handleError = useErrorHandler();
  const userActions = useUserActions();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await userActions.queryRecentlyUsedContentTypes();
      } catch (err) {
        handleError(err);
      }
    };

    fetchData();
  }, [handleError, userActions]);
};
